// extracted by mini-css-extract-plugin
export default {"subtitle":"ContractTerminatedSection_subtitle__bkTCa","address":"ContractTerminatedSection_address__+MTV-"};